export default __webpack_public_path__ + "static/media/background.e762d06b.svg";